import MuiDivider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const Divider = withStyles(styles)(MuiDivider);

export default Divider;
